import apiClient from "./apiService";

// Fetch Users
export const fetchUsers = async (page = 1, search = "", status = "") => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("search", search ?? "");
    params.append("status", status ?? "");
    const response = await apiClient.get(
      `/admin/users/admin-index?${params.toString()}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get single user
export const fetchUser = async (id) => {
  try {
    const response = await apiClient.get(`/api/users/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update user status
export const updateUserStatus = async (id, data) => {
  try {
    const response = await apiClient.put(`/admin/users/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
